// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jqiHjMRsGqEt6Z {\n  bottom: 2px;\n  left: 6px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkItemCheckbox": "jqiHjMRsGqEt6Z"
};
export default ___CSS_LOADER_EXPORT___;
